/**
 * Force Filestack uploads onto the custom S3 bucket (not Filestack internal_v2).
 * CDN URLs stay https://cdn.filestackcontent.com/{handle} — serving unchanged.
 *
 * Opt out locally with FILESTACK_FORCE_CUSTOM_S3=0 when using a Filestack app
 * that does not have healme-production-assets configured.
 */

export const FILESTACK_S3_DEFAULT_BUCKET = "healme-production-assets"
export const FILESTACK_S3_DEFAULT_REGION = "us-east-2"

function envFlagEnabled(value: string | undefined, defaultEnabled: boolean): boolean {
  if (value == null || value === "") return defaultEnabled
  return !["0", "false", "no", "off"].includes(value.toLowerCase())
}

export function filestackForceCustomS3Enabled(): boolean {
  return envFlagEnabled(process.env.FILESTACK_FORCE_CUSTOM_S3, true)
}

/** Picker option `storeTo` (filestack-js PickerOptions). */
export function filestackStoreTo():
  | { location: string; container: string; region: string }
  | undefined {
  if (!filestackForceCustomS3Enabled()) return undefined

  return {
    location: "s3",
    container: process.env.FILESTACK_S3_BUCKET || FILESTACK_S3_DEFAULT_BUCKET,
    region: process.env.FILESTACK_S3_REGION || FILESTACK_S3_DEFAULT_REGION
  }
}

/** Third argument to `client.upload(file, uploadOpts, storeOpts)`. */
export function filestackUploadStoreOptions():
  | { location: string; container: string; region: string }
  | undefined {
  return filestackStoreTo()
}

/** Merge storeTo into picker options without clobbering an explicit caller value. */
export function withFilestackStoreTo<T extends Record<string, unknown>>(pickerOptions: T): T {
  const storeTo = filestackStoreTo()
  if (!storeTo) return pickerOptions
  if (pickerOptions.storeTo) return pickerOptions
  return { ...pickerOptions, storeTo }
}
